<p-toast></p-toast>

<div class="card">
    <h2>Registro de Médico</h2>

    <form [formGroup]="medicoForm" (ngSubmit)="onSubmit()">
        <div class="formgrid grid">
            <!-- Usuario - CON VALIDACIÓN DE EMAIL -->
            <div class="field col-12 md:col-6">
                <label for="usuario">Usuario (Correo electrónico)*:</label>
                <input id="usuario" type="email" pInputText formControlName="usuario" [maxlength]="50"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['usuario'].touched && f['usuario'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['usuario'].touched && f['usuario'].invalid">
                    <small class="block" *ngIf="f['usuario'].errors?.['required']">
                        El usuario es requerido
                    </small>
                    <small class="block" *ngIf="f['usuario'].errors?.['email']">
                        Debe ser un correo electrónico válido (ej: usuario@dominio.com)
                    </small>
                    <small class="block" *ngIf="f['usuario'].errors?.['minlength']">
                        El usuario debe tener al menos 5 caracteres
                    </small>
                    <small class="block" *ngIf="f['usuario'].errors?.['maxlength']">
                        El usuario no puede exceder 50 caracteres
                    </small>
                </div>
            </div>
            
            <!-- Contraseña - CON VALIDACIÓN DE SEGURIDAD -->
            <div class="field col-12 md:col-6">
                <label for="password">Contraseña*:</label>
                <input id="password" type="password" pInputText [maxlength]="18" formControlName="password"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['password'].touched && f['password'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['password'].touched && f['password'].invalid">
                    <small class="block" *ngIf="f['password'].errors?.['required']">
                        La contraseña es requerida
                    </small>
                    <small class="block" *ngIf="f['password'].errors?.['minlength']">
                        La contraseña debe tener al menos 6 caracteres
                    </small>
                    <small class="block" *ngIf="f['password'].errors?.['maxlength']">
                        La contraseña no puede exceder 18 caracteres
                    </small>
                    <small class="block" *ngIf="f['password'].errors?.['pattern']">
                        La contraseña debe contener al menos: una mayúscula, una minúscula, un número y un carácter especial (@$!%*?&)
                    </small>
                </div>
            </div>
            
            <!-- Nombre - CON VALIDACIÓN DE SOLO LETRAS -->
            <div class="field col-12 md:col-6">
                <label for="nombre">Nombre*:</label>
                <input id="nombre" type="text" pInputText [maxlength]="100" formControlName="nombre"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['nombre'].touched && f['nombre'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['nombre'].touched && f['nombre'].invalid">
                    <small class="block" *ngIf="f['nombre'].errors?.['required']">
                        El nombre es requerido
                    </small>
                    <small class="block" *ngIf="f['nombre'].errors?.['pattern']">
                        El nombre solo debe contener letras y espacios
                    </small>
                    <small class="block" *ngIf="f['nombre'].errors?.['maxlength']">
                        El nombre no puede exceder 100 caracteres
                    </small>
                </div>
            </div>
            
            <!-- Alias -->
            <div class="field col-12 md:col-6">
                <label for="alias">Alias:</label>
                <input id="alias" type="text" pInputText formControlName="alias" [maxlength]="50"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['alias'].touched && f['alias'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['alias'].touched && f['alias'].invalid">
                    <small class="block" *ngIf="f['alias'].errors?.['maxlength']">
                        El alias no puede exceder 50 caracteres
                    </small>
                </div>
            </div>
            
            <!-- Primer Apellido - CON VALIDACIÓN -->
            <div class="field col-12 md:col-6">
                <label for="primerApellido">Apellido Paterno*:</label>
                <input id="primerApellido" type="text" pInputText [maxlength]="100" formControlName="primerApellido"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['primerApellido'].touched && f['primerApellido'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['primerApellido'].touched && f['primerApellido'].invalid">
                    <small class="block" *ngIf="f['primerApellido'].errors?.['required']">
                        El apellido paterno es requerido
                    </small>
                    <small class="block" *ngIf="f['primerApellido'].errors?.['pattern']">
                        Solo debe contener letras y espacios
                    </small>
                    <small class="block" *ngIf="f['primerApellido'].errors?.['maxlength']">
                        No puede exceder 100 caracteres
                    </small>
                </div>
            </div>
            
            <!-- Segundo Apellido -->
            <div class="field col-12 md:col-6">
                <label for="segundoApellido">Apellido Materno:</label>
                <input id="segundoApellido" type="text" pInputText [maxlength]="100" formControlName="segundoApellido"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['segundoApellido'].touched && f['segundoApellido'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['segundoApellido'].touched && f['segundoApellido'].invalid">
                    <small class="block" *ngIf="f['segundoApellido'].errors?.['pattern']">
                        Solo debe contener letras y espacios
                    </small>
                    <small class="block" *ngIf="f['segundoApellido'].errors?.['maxlength']">
                        No puede exceder 100 caracteres
                    </small>
                </div>
            </div>
            
            <!-- Entidad Federativa - REQUERIDO -->
            <div class="field col-12 md:col-6">
                <label for="estado">Entidad Federativa *:</label>
                <p-dropdown formControlName="fk_estado" inputId="estado" [options]="estados" optionLabel="label"
                    optionValue="value" styleClass="w-full" placeholder="Seleccione un Estado"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['fk_estado'].touched && f['fk_estado'].invalid}"
                    [emptyMessage]="'Sin resultados'" [emptyFilterMessage]="'Sin resultados'">
                </p-dropdown>
                <small class="p-error" *ngIf="f['fk_estado'].touched && f['fk_estado'].errors?.['required']">
                    La entidad federativa es requerida
                </small>
            </div>
            
            <!-- Institución - REQUERIDO -->
            <div class="field col-12 md:col-6">
                <label for="institucion">Institución *:</label>
                <p-dropdown formControlName="fk_institucion" inputId="institucion" [options]="instituciones"
                    optionLabel="label" optionValue="value" styleClass="w-full" placeholder="Seleccione una Institución"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['fk_institucion'].touched && f['fk_institucion'].invalid}"
                    [emptyMessage]="'Sin resultados'" [emptyFilterMessage]="'Sin resultados'">
                </p-dropdown>
                <small class="p-error" *ngIf="f['fk_institucion'].touched && f['fk_institucion'].errors?.['required']">
                    La institución es requerida
                </small>
            </div>
            
            <!-- Hospital - REQUERIDO -->
            <div class="field col-12 md:col-12">
                <label for="hospital">Hospital *: </label>
                <p-dropdown inputId="hospital" [options]="hospitales" formControlName="fk_hospital"
                    optionLabel="nomHospital" [showClear]="true" placeholder="Seleccione un hospital"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['fk_hospital'].touched && f['fk_hospital'].invalid}"
                    [emptyMessage]="'Sin resultados'">
                </p-dropdown>
                <small class="p-error" *ngIf="f['fk_hospital'].touched && f['fk_hospital'].errors?.['required']">
                    El hospital es requerido
                </small>
            </div>
            
            <!-- Especialidad - REQUERIDO -->
            <div class="field col-12 md:col-6">
                <label for="especialidad">Especialidad *:</label>
                <p-dropdown inputId="especialidad" [options]="especialidades" formControlName="fk_especialidad"
                    optionLabel="nomEspecialidad" [showClear]="true" placeholder="Seleccione una especialidad"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['fk_especialidad'].touched && f['fk_especialidad'].invalid}"
                    [emptyMessage]="'Sin resultados'">
                </p-dropdown>
                <small class="p-error" *ngIf="f['fk_especialidad'].touched && f['fk_especialidad'].errors?.['required']">
                    La especialidad es requerida
                </small>
            </div>
            
            <!-- Puesto - REQUERIDO -->
            <div class="field col-12 md:col-6">
                <label for="puesto">Puesto *:</label>
                <p-dropdown inputId="puesto" [options]="puestos" formControlName="fk_puesto" optionLabel="descripcion"
                    [showClear]="true" placeholder="Seleccione un puesto"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['fk_puesto'].touched && f['fk_puesto'].invalid}"
                    [emptyMessage]="'Sin resultados'">
                </p-dropdown>
                <small class="p-error" *ngIf="f['fk_puesto'].touched && f['fk_puesto'].errors?.['required']">
                    El puesto es requerido
                </small>
            </div>
            
            <!-- No. Consultorio - CON VALIDACIÓN -->
            <div class="field col-12 md:col-4">
                <label for="noconsultorio">No. Consultorio:</label>
                <input id="noconsultorio" type="text" pInputText [maxlength]="20" formControlName="noConsultorio"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['noConsultorio'].touched && f['noConsultorio'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['noConsultorio'].touched && f['noConsultorio'].invalid">
                    <small class="block" *ngIf="f['noConsultorio'].errors?.['pattern']">
                        Solo puede contener letras, números y guiones
                    </small>
                    <small class="block" *ngIf="f['noConsultorio'].errors?.['maxlength']">
                        No puede exceder 20 caracteres
                    </small>
                </div>
            </div>
            
            <!-- Tel Consultorio - CON VALIDACIÓN -->
            <div class="field col-12 md:col-4">
                <label for="telconsultorio">Teléfono Consultorio:</label>
                <input id="telconsultorio" type="text" pInputText formControlName="telefonoConsultorio" [maxlength]="10"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['telefonoConsultorio'].touched && f['telefonoConsultorio'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['telefonoConsultorio'].touched && f['telefonoConsultorio'].invalid">
                    <small class="block" *ngIf="f['telefonoConsultorio'].errors?.['pattern']">
                        El teléfono debe tener 10 dígitos numéricos
                    </small>
                </div>
            </div>
            
            <!-- Tel móvil - CON VALIDACIÓN -->
            <div class="field col-12 md:col-4">
                <label for="telmovil">Teléfono Móvil:</label>
                <input id="telmovil" type="text" pInputText [maxlength]="10" formControlName="telefonoMovil"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['telefonoMovil'].touched && f['telefonoMovil'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['telefonoMovil'].touched && f['telefonoMovil'].invalid">
                    <small class="block" *ngIf="f['telefonoMovil'].errors?.['pattern']">
                        El teléfono debe tener 10 dígitos numéricos
                    </small>
                </div>
            </div>
            
            <!-- Consultorio privado -->
            <div class="field col-12 md:col-6">
                <label for="hospitalconsultorioprivado">Nombre del Consultorio Privado:</label>
                <input id="hospitalconsultorioprivado" type="text" pInputText [maxlength]="200"
                    formControlName="hospitalConsultorioPrivado"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['hospitalConsultorioPrivado'].touched && f['hospitalConsultorioPrivado'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['hospitalConsultorioPrivado'].touched && f['hospitalConsultorioPrivado'].invalid">
                    <small class="block" *ngIf="f['hospitalConsultorioPrivado'].errors?.['maxlength']">
                        No puede exceder 200 caracteres
                    </small>
                </div>
            </div>
            
            <div class="field col-12 md:col-6"></div>
            
            <!-- Dirección consultorio privado -->
            <div class="field col-12 md:col-6">
                <label for="direccionconsultorioprivado">Dirección Consultorio Privado:</label>
                <input id="direccionconsultorioprivado" type="text" pInputText
                    formControlName="noConsultorioDireccionPrivado" [maxlength]="200"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['noConsultorioDireccionPrivado'].touched && f['noConsultorioDireccionPrivado'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['noConsultorioDireccionPrivado'].touched && f['noConsultorioDireccionPrivado'].invalid">
                    <small class="block" *ngIf="f['noConsultorioDireccionPrivado'].errors?.['maxlength']">
                        No puede exceder 200 caracteres
                    </small>
                </div>
            </div>
            
            <!-- Teléfono consultorio privado -->
            <div class="field col-12 md:col-6">
                <label for="telconsultorioprivado">Teléfono Consultorio Privado:</label>
                <input id="telconsultorioprivado" type="text" pInputText formControlName="telefonoConsultorioPrivado"
                    [maxlength]="10"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    [ngClass]="{'ng-invalid ng-dirty border-red-500': f['telefonoConsultorioPrivado'].touched && f['telefonoConsultorioPrivado'].invalid}">
                
                <div class="p-error text-sm mt-1" *ngIf="f['telefonoConsultorioPrivado'].touched && f['telefonoConsultorioPrivado'].invalid">
                    <small class="block" *ngIf="f['telefonoConsultorioPrivado'].errors?.['pattern']">
                        El teléfono debe tener 10 dígitos numéricos
                    </small>
                </div>
            </div>
        </div>
        
        <!-- Botones -->
        <div class="field col-12">
            <p-button type="button" label="Cancelar" (click)="cancelar()" styleClass="p-button-secondary mr-3">
            </p-button>
            <p-button type="submit" label="Guardar" icon="pi pi-save" [disabled]="medicoForm.invalid">
            </p-button>
        </div>
        
        <!-- Mensaje de error general -->
        <div class="field col-12" *ngIf="medicoForm.invalid && medicoForm.touched">
            <small class="p-error">El formulario contiene errores. Por favor, revise los campos marcados en rojo.</small>
        </div>
    </form>
</div>